import React, { useEffect, useState } from "react";
import { Col, Image, ListGroup, Nav, Row } from "react-bootstrap";
import "./Dashboard.css";
import { Link, useParams, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.png";
import Header from "../Components/Header";
import Footer from "../Components/Footer/Footer";
import apiClient from "../AppClient";
import { FaChevronDown, FaChevronUp, FaUsers, FaBoxes, FaLeaf, FaUserFriends, 
         FaMoneyBillWave, FaShoppingCart, FaShoppingBag, FaCreditCard, FaSeedling, 
         FaTrash, FaReceipt, FaExchangeAlt, FaCog, FaClipboardList } from "react-icons/fa";
import { Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const Dashboard = ({ currentComponent }) => {
  const { userInfo, setThePermissions, permissions,getPaymentMethods,paymentMethods } = useAuth();
  const [collapsed, setCollapsed] = useState(false);
  const [currentpage, setCurrentPage] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const location = useLocation();
  const [openSections, setOpenSections] = useState({
    definitions: false,
    users: false,
    reports: false,
    settings: false,
  });
  
  // Track active sections based on current path
  const [activeSections, setActiveSections] = useState({
    system: false,
    definitions: false,
    actions: false,
    reports: false
  });

  useEffect(() => {
    if (currentComponent) {
      setCurrentPage(currentComponent);
    }
    
    // Update active sections based on current path
    const path = location.pathname;
    setActiveSections({
      system: path.includes('/staff'),
      definitions: ['/suppliers', '/categories', '/products', '/fertilizers', 
                   '/customertypes', '/customers', '/expenses'].some(p => path.includes(p)),
      actions: path.includes('/transactions'),
      reports: path.includes('/Reports')
    });
    
  }, [currentComponent, location]);

  useEffect(() => {
    if (userInfo?.token) {
      // console.log(userInfo.token);
      apiClient.defaults.headers.common["Authorization"] = `Bearer ${userInfo.token}`;

      fetchpermissions()
      fetchPaymentMethods()
    }

  }, [userInfo]);


  const handleToggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const fetchpermissions = () => {
    setLoading(true);
    apiClient
      .get('/staff/permissions/user/')
      .then(response => {
        setThePermissions(response.data)
        setLoading(false)
        setError("")
      }
      )
      .catch(error => {
        if (error.response) {
          setError(error.response.data.detail)
          setLoading(false)
        }
        else {
          setError("حدث خطأ اثناء الاتصال بالسيرفر")
          setLoading(false)
        }

      });
  }
  const fetchPaymentMethods = () => {
    setLoading(true);
    apiClient
      .get('/transactions/payment-methods/')
      .then(response => {
        getPaymentMethods(response.data)
        setLoading(false)
        setError("")
      }
      )
      .catch(error => {
        if (error.response) {
          setError(error.response.data.detail || "حدث خطأ اثناء الاتصال بالسيرفر")
          setLoading(false)
        }
        else {
          setError("حدث خطأ اثناء الاتصال بالسيرفر")

          setLoading(false)
        }
      });
  }
  const toggleSection = (section) => {
    setOpenSections({
      ...openSections,
      [section]: !openSections[section]
    });
  };

  const isActive = (path) => {
    return location.pathname.includes(path) ? 'active-menu-item' : '';
  };

  const hasPermission = (codename) => {
    return permissions.some((perm) => perm.codename === codename);
  };
  return (
    <div
      className={` wrapper ${collapsed ? "active" : ""}`}
      style={{ display: "flex", minHeight: "100vh", width: "100vw" }}
    >
      {/* Sidebar */}
      <nav
        id="sidebar"
        className={` p-1 ${collapsed ? "active" : ""} ${!userInfo ? "d-none" : ""
          }`}
      >
        <Row className="sidebar-header">
          <Col className="text-center d-none "></Col>
          <Col>
            <button
              type="button"
              id="sidebarCollapse"
              className="btn btn-light d-block d-md-none"
              onClick={handleToggleSidebar}
            >
              <i className="fas fa-bars"></i>
            </button>
          </Col>
        </Row>
        <ul className=" list-unstyled components p-2">
          { }
          <li className={activeSections.system ? 'active-section' : ''}>
            <a
              href="#systemmenue"
              data-bs-toggle="collapse"
              aria-expanded={activeSections.system}
              className=" d-flex justify-content-between align-items-center text-light text-decoration-none"
              onClick={() => toggleSection('system')}
            >
              <span><FaCog className="me-2" /> النظام</span> 
              {openSections.system ? <FaChevronUp /> : <FaChevronDown />}
            </a>

            <ListGroup className={`collapse list-unstyled ps-5 ${activeSections.system ? 'show' : ''}`} id="systemmenue">
              {hasPermission("manage_staff") && (
                <Nav.Item>
                  <Nav.Link as={Link} to="/staff" className={isActive('/staff')}>
                    <FaUsers className="me-2" /> قائمة الموظفين
                  </Nav.Link>
                </Nav.Item>
              )}
            </ListGroup>
          </li>
          
          <li className={activeSections.definitions ? 'active-section' : ''}>
            <a
              href="#homeSubmenu"
              data-bs-toggle="collapse"
              aria-expanded={activeSections.definitions}
              className=" d-flex justify-content-between align-items-center text-light text-decoration-none"
              onClick={() => toggleSection('definitions')}
            >
              <span><FaClipboardList className="me-2" /> التعريفات</span>
              {openSections.definitions ? <FaChevronUp /> : <FaChevronDown />}
            </a>

            <ListGroup className={`collapse list-unstyled ps-5 ${activeSections.definitions ? 'show' : ''}`} id="homeSubmenu">
              {hasPermission("manage_suppliers") && (
                <Nav.Item>
                  <Nav.Link as={Link} to="/suppliers" className={isActive('/suppliers')}>
                    <FaUserFriends className="me-2" /> قائمة الموردين
                  </Nav.Link>
                </Nav.Item>
              )}
              {hasPermission("manage_types_of_items") && (
                <Nav.Item>
                  <Nav.Link as={Link} to="/categories" className={isActive('/categories')}>
                    <FaBoxes className="me-2" /> قائمة أنواع الأصناف
                  </Nav.Link>
                </Nav.Item>
              )}
              {hasPermission("manage_items") && (
                <Nav.Item>
                  <Nav.Link as={Link} to="/products" className={isActive('/products')}>
                    <FaBoxes className="me-2" /> قائمة الأصناف
                  </Nav.Link>
                </Nav.Item>
              )}
              {hasPermission("manage_fertilizers") && (
                <Nav.Item>
                  <Nav.Link as={Link} to="/fertilizers" className={isActive('/fertilizers')}>
                    <FaSeedling className="me-2" /> قائمة الأسمدة
                  </Nav.Link>
                </Nav.Item>
              )}
              {hasPermission("manage_types_of_customers") && (
                <Nav.Item>
                  <Nav.Link as={Link} to="customertypes" className={isActive('/customertypes')}>
                    <FaUsers className="me-2" /> قائمة أنواع الزبائن
                  </Nav.Link>
                </Nav.Item>
              )}
              {hasPermission("manage_customers") && (
                <Nav.Item>
                  <Nav.Link as={Link} to="/customers" className={isActive('/customers')}>
                    <FaUsers className="me-2" /> قائمة الزبائن
                  </Nav.Link>
                </Nav.Item>
              )}
              {hasPermission("manage_expenses") && (
                <Nav.Item>
                  <Nav.Link as={Link} to="/expenses" className={isActive('/expenses')}>
                    <FaMoneyBillWave className="me-2" /> قائمة المصاريف
                  </Nav.Link>
                </Nav.Item>
              )}
            </ListGroup>
          </li>
          
          {/* transactions */}
          <li className={activeSections.actions ? 'active-section' : ''}>
            <a
              href="#actionSubmenu"
              data-bs-toggle="collapse"
              aria-expanded={activeSections.actions}
              className=" d-flex justify-content-between align-items-center text-light text-decoration-none"
              onClick={() => toggleSection('actions')}
            >
              <span><FaExchangeAlt className="me-2" /> العمليات</span>
              {openSections.actions ? <FaChevronUp /> : <FaChevronDown />}
            </a>

            <ListGroup
              className={`collapse list-unstyled ps-5 ${activeSections.actions ? 'show' : ''}`}
              id="actionSubmenu"
            >
              {hasPermission("manage_purchases_transaction") && (
                <Nav.Item>
                  <Nav.Link as={Link} to="/transactions/purchases" className={isActive('/transactions/purchases')}>
                    <FaShoppingCart className="me-2" /> المشتريات
                  </Nav.Link>
                </Nav.Item>
              )}
              {hasPermission("manage_sales_transaction") && (
                <Nav.Item>
                  <Nav.Link as={Link} to="/transactions/sales" className={isActive('/transactions/sales')}>
                    <FaShoppingBag className="me-2" /> المبيعات
                  </Nav.Link>
                </Nav.Item>
              )}
              {hasPermission("manage_customers_payment") && (
                <Nav.Item>
                  <Nav.Link as={Link} to="transactions/CustomerPaymentsDashboard" className={isActive('/transactions/CustomerPaymentsDashboard')}>
                    <FaCreditCard className="me-2" /> تسديدات الزبائن
                  </Nav.Link>
                </Nav.Item>
              )}

              {hasPermission("manage_suppliers_payment") && (
                <Nav.Item>
                  <Nav.Link as={Link} to="transactions/SupplierPaymentsDashboard" className={isActive('/transactions/SupplierPaymentsDashboard')}>
                    <FaCreditCard className="me-2" /> تسديدات الموردين
                  </Nav.Link>
                </Nav.Item>
              )}

              {hasPermission("manage_fertilization") && (
                <Nav.Item>
                  <Nav.Link as={Link} to="transactions/FertilizationTransactions" className={isActive('/transactions/FertilizationTransactions')}>
                    <FaSeedling className="me-2" /> التسميد
                  </Nav.Link>
                </Nav.Item>
              )}

              {hasPermission("manage_damages") && (
                <Nav.Item>
                  <Nav.Link as={Link} to="transactions/damages" className={isActive('/transactions/damages')}>
                    <FaTrash className="me-2" /> الاتلاف
                  </Nav.Link>
                </Nav.Item>
              )}

              {hasPermission("manage_expenses_transaction") && (
                <Nav.Item>
                  <Nav.Link as={Link} to="transactions/expenses" className={isActive('/transactions/expenses')}>
                    <FaMoneyBillWave className="me-2" /> المصاريف
                  </Nav.Link>
                </Nav.Item>
              )}

              {hasPermission("manage_cash_handover") && (
                <Nav.Item>
                  <Nav.Link as={Link} to="transactions/cashhandovers" className={isActive('/transactions/cashhandovers')}>
                    <FaExchangeAlt className="me-2" /> تسليم الصندوق
                  </Nav.Link>
                </Nav.Item>
              )}
            </ListGroup>
          </li>
          
          <li className={activeSections.reports ? 'active-section' : ''}>
            <a
              href="#kashfSubmenu"
              data-bs-toggle="collapse"
              aria-expanded={activeSections.reports}
              className="d-none d-flex justify-content-between align-items-center text-light text-decoration-none"
              onClick={() => toggleSection('reports')}
            >
              <span><FaReceipt className="me-2" /> الكشوفات</span> 
              {openSections.reports ? <FaChevronUp /> : <FaChevronDown />}
            </a>

            <ListGroup
              className={`collapse list-unstyled ps-5 ${activeSections.reports ? 'show' : ''}`}
              id="kashfSubmenu"
            >
              <Nav.Item>
                <Nav.Link as={Link} to="">
                  كشف المبيعات{" "}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="">
                  كشف المبيعات لزبون
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="Reports/sales & purchases/PurchasesReport">
                  {" "}
                  كشف المشتريات
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="">
                  كشف المشتريات لمورد
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="Reports/InventorySummaryReport">
                  كشف الموجودات
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="Reports/MostSoldReport">
                  كشف الاصناف الاكثر مبيعا
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="">
                  كشف الاصناف الاقل مبيعا
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="Reports/MostFrequentCustomersReport">
                  كشف الزبون الاكثر ترددا{" "}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="Reports/SuppliersAnalysisReport">
                  كشف تحليل الموردين
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="Reports/installments/InstallmentsReport">
                  كشف الدفعات المتوقعه من الزبائن
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="">
                  {" "}
                  كشف الدفعات المتوقعه الى الموردين
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="Reports/DiscountsSavingsReport">
                  كشف التوفير من الخصومات{" "}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="Reports/FertilizationsReport">
                  كشف التسميد لنبته معينه
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="Reports/FertilizingDateReport">
                  كشف مواعيد التسميد
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="Reports/ExpenseReport">
                  {" "}
                  كشف المصاريف
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="Reports/CashhandoverReport">
                  كشف حركات الصندوق
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="Reports/FundSummaryReport">
                  كشف ملخص للصندوق
                </Nav.Link>
              </Nav.Item>
              
            </ListGroup>
          </li>
        </ul>
      </nav>
      <div style={{ flexGrow: 1, height: "100%" }} className="mt-2">
        <Header />
        {/* Main content */}
        <div id="dashboard-main" style={{ padding: "20px" }}>
          {userInfo && (
            <button
              type="button"
              id="sidebarCollapse"
              className="btn btn-light"
              onClick={handleToggleSidebar}
            >
              <i className="fas fa-bars"></i>
            </button>
          )}
          <div className="dashboard">
            <div className="content bg-light p-2">
              {error && <p style={{ color: "red" }}>{error}</p>}
              <Outlet /> {/* هنا سيتم عرض المحتوى الديناميكي */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
